export default "__VITE_ASSET__DT4kLTLT__"